import { linkTemplates } from '@atlassian/mpac-utils';
import { useMemo } from 'react';
export const useLinkTemplates = _ref => {
  let {
    adminHubBaseUrl,
    mpacBaseUrl,
    mpacCdnBaseUrl,
    macBaseUrl,
    wacBaseUrl,
    atlassianCommunityBaseUrl
  } = _ref;
  return useMemo(() => linkTemplates({
    adminHubBaseUrl,
    mpacBaseUrl,
    mpacCdnBaseUrl,
    macBaseUrl,
    wacBaseUrl,
    atlassianCommunityBaseUrl
  }), [adminHubBaseUrl, mpacBaseUrl, mpacCdnBaseUrl, macBaseUrl, wacBaseUrl, atlassianCommunityBaseUrl]);
};